import {
	Box,
	IconButton,
	ListItem,
	makeStyles,
	Typography
} from '@material-ui/core';
import React, { useState } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { Confirmation } from '../../../../../components/modals';
import {
	deleteElement,
	updateElement
} from '../../../../../store/news/actions';
import EditModal from '../../../EditModal/EditModal';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: '8px'
	},
	title: {},
	titleInactive: {
		color: 'gray'
	},
	buttons: {
		marginLeft: 'auto'
	}
}));

export default (props) => {
	const { item } = props;
	const classes = useStyles();
	const data = item.content.filter((item) => item.lang === 'hu')[0];
	const [open, setOpen] = useState(false);
	const [editOpen, setEditOpen] = useState(false);

	const deleteItem = () => {
		deleteElement(item.id);
	};

	const updateItem = (data) => {
		updateElement(item.id, data);
	};

	return (
		<ListItem divider className={classes.root}>
			<Typography
				className={item.active ? classes.title : classes.titleInactive}>
				{data.title}
			</Typography>
			<Box className={classes.buttons}>
				<IconButton onClick={() => setEditOpen(true)}>
					<EditIcon />
				</IconButton>
				<IconButton onClick={() => setOpen(true)}>
					<DeleteForeverIcon />
				</IconButton>
				<Confirmation
					open={open}
					setOpen={setOpen}
					onConfirm={deleteItem}
					title='Biztosan törölni szeretnéd?'>
					Ez a művelet végleges és visszafordíthatatlan!
				</Confirmation>
				<EditModal
					open={editOpen}
					setOpen={setEditOpen}
					onConfirm={updateItem}
					item={item}
				/>
			</Box>
		</ListItem>
	);
};
